import { render, staticRenderFns } from "./special_detail.vue?vue&type=template&id=39b2d79f&scoped=true"
import script from "./special_detail.vue?vue&type=script&lang=js"
export * from "./special_detail.vue?vue&type=script&lang=js"
import style0 from "./special_detail.vue?vue&type=style&index=0&id=39b2d79f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2d79f",
  null
  
)

export default component.exports